import ConfirmacionAccion from '@/components/ConfirmacionAccion.vue';
import { ACCIONES_A_CONFIRMAR } from '../utils';

export default {
  components: {
    ConfirmacionAccion,
  },
  data() {
    return {
      servicioListarItems: async () => {
        return Promise.reject({ response: { data: { mensaje: 'No se ha definido el servicio para listar' } } });
      },
      nombreRecurso: 'Ítem',
      items: [],
      item: null,
      cargando: false,
      searchQuery: '',
      accionesAConfirmar: ACCIONES_A_CONFIRMAR,
      confirmacion: {
        titulo: '',
        mensaje: '',
        realizandoAccion: false,
        fnAceptar: () => {
          window.console.log('Aceptar');
        },
      },
    };
  },
  methods: {
    async listarMixin(params) {
      this.cargando = true;

      try {
        const { data } = await this.servicioListarItems({ params });
        const { datos, mensaje } = data;

        this.items = datos;
        this.$notify({
          group: 'notifications',
          title: this.nombreRecurso.toUpperCase(),
          text: mensaje || 'Listado exitoso',
          type: 'success',
        });
      } catch (error) {
        const { mensaje } = error?.response?.data;

        window.console.log(error);

        this.items = [];
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al listar',
          type: 'error',
        });
      } finally {
        this.item = null;
        this.cargando = false;
      }
    },
    definirAccion(accion) {
      return async () => {
        this.confirmacion.realizandoAccion = true;

        try {
          const response = await this.getResponseAccion(accion);
          const mensaje = response?.data?.mensaje;

          this.listar();
          this.$refs.confirmacionRef.cerrar();
          this.$notify({
            group: 'notifications',
            title: 'Gestiones',
            text: mensaje || 'Acción realizada con éxito',
            type: 'success',
          });
        } catch (error) {
          const { mensaje } = error?.response?.data;

          window.console.log(error);

          this.$notify({
            group: 'notifications',
            title: 'Error',
            text: mensaje || 'Ocurrió un error al realizar la acción',
            type: 'error',
          });
        } finally {
          this.confirmacion.realizandoAccion = false;
        }
      };
    },
    selectItem(item) {
      this.item = item;
    },
    updateSearchQuery(val) {
      this.$refs.listadoRef.updateSearchQuery(val);
    },
    confirmacionAccion(accion, identificador = '') {
      if (
        ![
          this.accionesAConfirmar.ACTIVAR,
          this.accionesAConfirmar.DESACTIVAR,
          this.accionesAConfirmar.ELIMINAR,
        ].includes(accion) ||
        !this.item
      ) {
        return;
      }

      switch (accion) {
        case this.accionesAConfirmar.ACTIVAR:
          this.confirmacion.titulo = `Activación de ${this.nombreRecurso}`;
          break;
        case this.accionesAConfirmar.DESACTIVAR:
          this.confirmacion.titulo = `Desactivación de ${this.nombreRecurso}`;
          break;
        case this.accionesAConfirmar.ELIMINAR:
          this.confirmacion.titulo = `Elimación de ${this.nombreRecurso}`;
          break;
      }

      this.confirmacion.mensaje = `¿Está seguro de ${accion} ${this.nombreRecurso.toLowerCase()}: ${identificador}?`;
      this.confirmacion.fnAceptar = this.definirAccion(accion);
      this.$refs.confirmacionRef.abrir();
    },
  },
};
